<template>
  <div class="products-hctx-customer-page-content flex flex-col items-center text-center w-full ">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem  max-ml:object-cover max-ml:object-[24%]" src="/images/pages/products/hctx-customer/banner.png" alt="门店收银系统" />
      <!-- <PageContentCenter class="text-[#616671] absolute top-[8.5rem]">
        <h2 class="text-2.63rem text-[#102136] mb-[32px] font-semibold">
          门店收银系统
        </h2>
        <p class="">简单好用、轻松搞定收银,让您的店铺在竞争中脱颖而出!</p>
      </PageContentCenter> -->
    </section>
    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/hyzx.png"></Pic>
    </section>

    <section class="relative w-full">
      <PageContentCenter class="flex flex-col items-center mb-3.13rem">
        <h2 class="text-[32px] text-[#272E3B] pt-[5rem] mb-35.04px font-bold">
          {{ content.businessIntroduction.title }}
        </h2>
        <h3 class="relative text-[#616671]  mb-18.24px w-41.25rem max-ml:w-100%">
          {{ content.businessIntroduction.subTitle }}
        </h3>
      </PageContentCenter>

      <PageContentCenter class="relative flex text-[16px] pb-156.8px max-ml:flex-col max-ml:pb-20px">
        <Pic src="/images/pages/products/hctx-customer/t-2.png"
          class="w-47.5rem h-31.25rem mr-[2.625rem] max-ml:h-auto max-ml:w-100%">
        </Pic>

        <div class="relative text-left pt-5.69rem max-ml:pt-0">
          <h5 class="text-#272E3B text-1.5rem mb-0.5rem">{{ content.businessIntroduction.moduleTilte }}</h5>
          <h6 class="text-#616671 text-1rem mb-2.25rem">{{ content.businessIntroduction.moduleDesc }}</h6>
          <ul class="features-group-ul">
            <li v-for="desc in content.businessIntroduction.descList"
              class="text-[#454656] text-1rem mb-1.5rem features-group-li">
              {{ desc }}
            </li>
          </ul>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full h-51.25rem max-ml:h-auto">
      <h2 class="text-[32px] text-[#272E3B] pt-[5rem] pb-1.5rem font-bold bg-[#EFF7FF]">
        <PageContentCenter>
          {{ content.featuresIntroduction.title }}
        </PageContentCenter>
      </h2>

      <section class="bg-[#EFF7FF] h-100% max-ml:hidden">
        <PageContentCenter class="relative hctx-customer-product-functions">
          <v-tabs v-model="tab" align-tabs="center" color="#1967F9">
            <v-tab :value="item.title" v-for="item in content.featuresIntroduction.groups">{{ item.title }}</v-tab>
          </v-tabs>

          <v-tabs-window v-model="tab">
            <v-tabs-window-item class="flex text-left justify-center gap-160px"
              v-for="item in content.featuresIntroduction.groups" :value="item.title">
              <div class="pt-11rem">
                <h3 class="text-#1967F9 text-1.75rem mb-1.5rem">{{ item.title }}</h3>
                <ul class="features-group-ul w-25.19rem ">
                  <li class="features-group-li mb-1rem" v-for="value in item.descList">{{ value }}</li>
                </ul>
              </div>
              <Pic :src="item.mainImage" class="w-42.5rem h-30rem mt-2rem"></Pic>
            </v-tabs-window-item>
          </v-tabs-window>

        </PageContentCenter>
      </section>
      <section class="bg-[#EFF7FF] h-100% hidden max-ml:inline">
        <PageContentCenter class="flex text-left justify-center gap-20px flex-col"
          v-for="item in content.featuresIntroduction.groups" :value="item.title">
          <div class="pt-20px pl-20px">
            <h3 class="text-#1967F9 text-1.75rem mb-1.5rem">{{ item.title }}</h3>
            <ul class="features-group-ul w-full ">
              <li class="features-group-li mb-1rem" v-for="value in item.descList">{{ value }}</li>
            </ul>
          </div>
          <Pic :src="item.mainImage" class="w-full h-auto"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="relative w-full hctx-customer-product-advantage max-ml:h-auto max-ml:hidden">
      <!-- <h2 class="text-[32px] text-[#272E3B]  font-bold ">
        <PageContentCenter>
          {{ content.advantage.title }}
        </PageContentCenter>
      </h2> -->
      <Pic src="/images/pages/products/hctx-customer/b-1.png"
          class="w-100% aspect-[2.34]"></Pic>
      <PageContentCenter class="text-[#272E3B] relative pt-160px max-ml:hidden">
        <!-- <Pic src="/images/pages/products/hctx-customer/b-1.png"
          class="w-635.52px h-[592px] absolute left-1/2 -translate-x-1/2 "></Pic> -->
        <!-- <ul class="flex justify-center gap-39.04px relative">
          <li v-for="item in content.advantage.list" class="hctx-customer-product-advantage-item absolute left-0 top-0">
            <div class="flex absolute gap-22.08px" :class="[
              `text-${item.diction}`,
              item.diction === 'right' ? `flex-row-reverse` : ``,
              item.diction === 'center' ? `w-33rem` : `w-16rem`,
              `left-${item.left}`,
              `top-${item.top}`,
            ]" :style="{
              'left': item.left,
              'top': item.top
            }">
              <div class="w-full">
                <h5 class="text-1.25rem font-semibold  text-[#375FF2] mb-[1rem]">{{ item.title }}</h5>
                <p v-for="value in item.desc" class="text-[#8F8F8F] text-0.88rem mb-[1rem]">
                  {{ value }}
                </p>
              </div>
            </div>
          </li>
        </ul> -->
      </PageContentCenter>
    </section>
    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { useSeoMeta } from 'nuxt/app'
useSeoMeta({
  title: '会员中心',
  description: '旨在通过建立会员体系，增强用户粘性，提升用户忠诚度，促进消费和参与度，同时为企业提供更精准的用户洞察和营销渠道。',
})
const tab = ref(null)
const content = shallowReactive({
  businessIntroduction: {
    title: '和成天下会员中心',
    // 副标题
    subTitle: '旨在通过建立会员体系，增强用户粘性，提升用户忠诚度，促进消费和参与度，同时为企业提供更精准的用户洞察和营销渠道。',
    desc: '',
    mainImage: '/images/pages/products/hctx-customer/Frame 427321214@2x.png',
    moduleTilte: '小程序介绍',
    moduleDesc: '2024年10月17日，“和成天下会员中心”小程序正式上线。',
    descList: [
      '该项目基于口味王会员体系的战略延伸与独立运营规划，旨在为“和成天下”品牌打造专属的数字化会员平台。',
      '和成天下小程序实现了会员服务、活动运营、积分成长、数据分析等全流程的闭环能力。',
      '截至目前，平台累计用户数已突破 7000万+，形成了稳定、高活跃的会员用户群体。'
    ],
  },
  featuresIntroduction: {
    title: '和成天下会员功能',
    desc: '',
    groups: [
      {
        title: '营销活动体系',
        desc: '',
        descList: [
          '支持扫码抽奖、秒杀抽奖等多类型活动配置，具备高并发处理能力，保障大流量活动的稳定运行；',
          '实时监控活动数据，支持中奖统计、库存监控、发奖追踪等全流程管理。',
        ],
        mainImage: '/images/pages/products/hctx-customer/1.png',

      },
      {
        title: 'B端数据运营平台',
        desc: '',
        descList: [
          '提供完整的报表与数据分析能力，支持按时间、地区、活动类型维度查看；',
          '实时监控扫码行为、用户活跃度、活动数据埋点等，帮助业务侧精准掌握会员运营数据。',],

        mainImage: '/images/pages/products/hctx-customer/2.png',

      },
      {
        title: '日常活动与用户互动',
        desc: '',
        descList: ['实现线上线下活动联动：线上推广引流至线下，增强会员粘性；',
          '节日主题活动设计、个性化活动定制等，提升用户参与度与品牌活跃度；',
          '通过丰富的活动形式，促进用户复购与品牌忠诚度。',],

        mainImage: '/images/pages/products/hctx-customer/3.png',

      },
      {
        title: '积分体系',
        desc: '',
        descList: ['积分获取途径多样，与扫码、活动、任务等场景深度结合；',

          '用户可在积分商城中兑换实物奖品、优惠券、专属权益；',

          '通过积分激励体系提升用户活跃与参与度，形成健康的运营循环。',],

        mainImage: '/images/pages/products/hctx-customer/4.png',

      },
      {
        title: '充值服务体系',
        desc: '',
        descList: ['提供便捷的线上充值功能，支持用户充值余额购买；',
          '打通支付、账户、资产管理闭环，保障资金安全与流转透明。',],
        mainImage: '/images/pages/products/hctx-customer/5.png',
      },
      {
        title: '会员等级体系',
        desc: '',
        descList: [
          '拥有完善的等级成长机制：通过扫码、消费、任务等方式提升成长值；',
          '不同等级会员可享受差异化权益，高等级会员可获得更高价值的专属奖励与福利。'
        ],
        mainImage: '/images/pages/products/hctx-customer/6.png',
      }
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '提升用户粘性与复购率',
        desc: [
          '通过抽奖、任务、积分兑换等多元互动方式，增强用户参与感与品牌归属感；',
          '精准运营与差异化激励机制有效提升会员复购率与活跃度。'
        ],
        icon: '/images/pages/products/hctx-customer/Frame 2147229306@2x.png',
        diction: 'center',
        left: '28.5rem',
        top: '-8.4375rem'
      },
      {
        title: '数据驱动精细化运营',
        desc: [
          '后台数据平台支持活动监控、会员分析；',
          '为业务决策提供实时、可视化数据支撑，推动精细化科学化运营。'
        ],
        briefBack: '/images/pages/products/hctx-customer/Group 1171274812@2x.png',
        icon: '/images/pages/products/hctx-customer/Frame 2147229310@2x.png',
        diction: 'left',
        left: '67.25rem',
        top: '11.25rem'
      },
      {
        title: '助力品牌私域增长',
        desc: [
          '小程序作为私域核心阵地，沉淀用户资产强化品牌触达。',
          '结合营销活动与会员权益，形成持续增长的品牌私域生态。'
        ],
        icon: '/images/pages/products/hctx-customer/Frame 2147229309@2x.png',
        diction: 'left',
        left: '56.25rem',
        top: '29.375rem'
      },
      {
        title: '强化会员生命周期管理',
        desc: [
          '以会员等级、积分成长、权益体系为核心构建完整的用户成长路径；',
          '实现从“注册激活—成长留存—活跃复购”的全周期管理，提升用户长期价值'
        ],
        icon: '/images/pages/products/hctx-customer/Frame 2147229308@2x.png',
        diction: 'right',
        left: '18.75rem',
        top: '29.375rem'
      }, {
        title: '品牌数字化运营支撑',
        desc: [
          '构建和成天下品牌专属会员平台，实现品牌独立运营与数字化资产沉淀；', '支撑从用户触达、互动到留存的完整运营链路，助力品牌数字化升级。'
        ],
        icon: '/images/pages/products/hctx-customer/Frame 2147229307@2x.png',
        diction: 'right',
        left: '6.5rem',
        top: '11.25rem'
      },
    ]
  }
})
</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-hctx-customer-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  // -------------------

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 32px;

      &::before {
        position: absolute;
        z-index: 0;
        top: 4px;
        left: 0;
        width: 1.06rem;
        height: 1.06rem;
        background-image: url("/images/pages/products/hctx-customer/gou.png");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
      }
    }
  }

  .hctx-customer-product-functions {
    :deep(.v-btn__content) {
      height: 3rem;
      font-size: 1.13rem;
    }
  }
}

.hctx-customer-product-advantage {
  background-image: url("/images/pages/products/hctx-customer/Group 1171274840@2x.png");
}
</style>
